<template>
  <div class="chre-box">
    <!-- 头 -->
    <div class="head">
      <img src="../../../assets/aboutus/lvju.png" alt />
      <span>企业简介</span>
    </div>
    <div class="txt">
      <p>河南豫都包装有限公司成立于1994年，现工厂坐落于郑州北·中原印刷包装产业园9-B栋（河南天之彩装印务有限公司），现拥有最先进的五色海德堡印刷机，全新多用进口自动烫金模切机，全新自动覆膜机，多台手动烫金机，模切机，自动一体化粘袋机，技术力量雄厚，拥有全套印前、印中、印后加工自动化生产设备，在信息化高速公路上拥有先进的印包ERP管理系统，为企业管理保驾护航！</p>
      <p>豫都包装是一家集策划、设计、印刷、制作为一体，商务手提袋，商务高端包装供应链制造商，为同行业提供产品供应服务。多年来秉承先进的理念、务实诚信的态度服务客户，旨在为打造尖端、高质量的印包产品和专业化的优良服务。经过不懈的创新和努力，奉行“质量第一、客户至上”的经营理念，博得了广大客户的认可和赞誉。</p>
      <div class="pic-ab">
        <img src="../../../assets/aboutus/lou.png" alt />
      </div>
    </div>
    <div class="head">
      <img src="../../../assets/aboutus/lvju.png" alt />
      <span>业务范围</span>
    </div>
    <div class="txt">
      <p>豫都包装是一家集策划、设计、印刷、制作为一体，商务手提袋，商务高端包装供应链制造商，为同行业提供产品供应服务。多年来秉承先进的理念、务实诚信的态度服务客户，旨在为打造尖端、高质量的印包产品和专业化的优良服务。经过不懈的创新和努力，奉行“质量第一、客户至上”的经营理念，博得了广大客户的认可和赞誉。</p>
      <!-- <div class="pic-ab">
        <video src="../../../assets/aboutus/yudu.mp4" controls width="458" height="289"></video>
      </div>-->
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="less" scoped>
.chre-box {
  margin-top: 40px;
  background: #fff;
  padding: 30px;
  box-sizing: border-box;
  .head {
    display: flex;
    align-items: center;
    span {
      margin-left: 10px;
      font-size: 16px;
      color: #666666;
      font-weight: bold;
    }
    margin-bottom: 9px;
  }
  .txt {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 28px;
    color: #666666;
    p {
      width: 100%;
      word-break: break-all; //只对英文起作用，以字母作为换行依据。
      word-wrap: break-word; //只对英文起作用，以单词作为换行依据。
      white-space: pre-wrap;
    }
    .pic-ab {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 320px;
      video {
        outline: none;
      }
    }
  }
}
</style>